(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/assets/javascripts/views/play-package-page.js') >= 0) return;  svs.modules.push('/modules/lotto/assets/javascripts/views/play-package-page.js');

'use strict';

const {
  productMapping
} = svs.numbergames;
svs.lotto.views.PlayPackagePage = Marionette.View.extend({
  viewOptions: ['size', 'showDrawCount', 'showPlayTogether'],
  size: 100,
  showDrawCount: true,
  showPlayTogether: true,
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'lotto',
    component: 'play'
  }],
  regions: {
    rowsContainerRegion: '#ngRowsContainerRegion',
    betslipRegion: '#ngBetslipRegion',
    payfooterRegion: '#ngPayfooterRegion'
  },
  template(data) {
    return svs.lotto.templates.play_page(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.lotto.components.play) {
      const model = this.model || new svs.numbergames.game_model.models.Wager({
        productId: productMapping.CONSTANTS.LOTTO,
        jokerPrice: 10,
        jokerRow: svs.numbergames.rules.joker.getHuxfluxedRow(),
        rowPriceMulti: 2,
        selectedDays: [svs.numbergames.game.draw.upcomingDrawProduct],
        isPackage: true
      }, {
        bagTypeIdMap: svs.lotto.data.bagTypeIdMap,
        storageKey: 'package',
        parse: true,
        hasTickets: svs.lotto.data.hasTickets
      });
      model.setPackage(this.size);
      this.showChildView('rowsContainerRegion', new svs.lotto.components.play.views.PackageRowsContainer({
        model,
        size: this.size
      }));
      this.showChildView('betslipRegion', new svs.lotto.components.play.views.Betslip({
        model,
        showJoker: false,
        showParticipation: false,
        showDrawCount: this.showDrawCount,
        showPlayTogether: this.showPlayTogether
      }));
      this.showChildView('payfooterRegion', new svs.lotto.components.play.views.Payfooter({
        model
      }));
    }
  }
});

 })(window);